import { ObtainedViaFilter, ObtainedViaTypes, PrincipalFilter, PrincipalTypeEnum, RequestBodyForCurrentAccessControl } from "./requestBodyForCurrentAccessControl";
import { RequestBodyForCurrentAccessControlBasedOnInformationAssets } from "./requestBodyForCurrentAccessControlBasedOnInformationAssets";

export class InputsforCurrentAccessControlsBasedOnSystemResource {
  systemId: string;
  systemResourceType: string;
  systemResource: string | null;
  resource: string | null;
  obtainedVia: string | null;
  principalId: string | null;
  userGroupType: string | null;
  userGroupId: string | null;
  systemUserGroupId: string | null;
  resourceId: string | null;
  obtainedViaType: string | null;
  pageNumber: number;
  pageSize: number;
  toShowFor: { user: boolean; userGroup: boolean };

  constructor(input: {
    systemId: string;
    systemResourceType: string;
    systemResource: string | null;
    resource: string | null;
    obtainedVia: string | null;
    principalId: string | null;
    userGroupType: string | null;
    userGroupId: string | null;
    systemUserGroupId: string | null;
    resourceId: string | null;
    obtainedViaType: string | null;
    pageNumber: number;
    pageSize: number;
    toShowFor: { user: boolean; userGroup: boolean };
  }) {
    this.pageNumber = input.pageNumber;
    this.pageSize = input.pageSize;
    this.principalId = input.principalId;
    this.obtainedVia = input.obtainedVia;
    this.systemResourceType = input.systemResourceType;
    this.systemResource = input.systemResource;
    this.userGroupType = input.userGroupType;
    this.userGroupId = input.userGroupId;
    this.resource = input.resource;
    this.systemId = input.systemId;
    this.resourceId = input.resourceId;
    this.obtainedViaType = input.obtainedViaType;
    this.systemUserGroupId = input.systemUserGroupId;
    this.toShowFor = input.toShowFor;
  }

  principal(): Nullable<PrincipalFilter> {
    if(this.principalId !== null) {
      return {
        type: PrincipalTypeEnum.User,
        email: this.principalId,
        userGroupId: null,
        userGroupType: null,
      }
    }
    if(this.userGroupId !== null && this.toShowFor.userGroup === true) {
      return {
        type: PrincipalTypeEnum.UserGroup,
        email: null,
        userGroupId: this.userGroupId,
        userGroupType: this.userGroupType,
      }
    }
    return null;
  } 

  generateObtainVia(): Nullable<ObtainedViaFilter> {
    let name: Nullable<ObtainedViaTypes> = null;
    if (this.obtainedViaType === ObtainedViaTypes.DirectAccess) {
      name = ObtainedViaTypes.DirectAccess
    }
    if (this.userGroupId !== null && this.toShowFor.user === true) {
      name = ObtainedViaTypes.UserGroup
    }
    if (this.systemUserGroupId !== null) {
      name = ObtainedViaTypes.SystemUserGroup
    }
    return {
      name: this.obtainedVia,
      type: name !== null?{
        name: name,
        id: this.userGroupId??this.systemUserGroupId,
        type: this.userGroupType
      }:null
    }
  }

  requestParams(): RequestBodyForCurrentAccessControl {
    return {
      page: {
        number: this.pageNumber,
        size: this.pageSize
      },
      filters: {
        systemId: this.systemId,
        principal: this.principal(),
        systemResource: {
          type: this.systemResourceType,
          name: this.systemResource,
        },
        resource: {
          name: this.resource,
          id: this.resourceId,
        },
        obtainedVia: this.generateObtainVia(),
      }
    };
  }
}

export class InputsForCurrentAccessControlsBasedOnInformationAsset {
  systemId: string;
  systemResourceType: string;
  resource: string | null;
  obtainedVia: string | null;
  principalId: string | null;
  userGroupType: string | null;
  userGroupId: string | null;
  resourceGroup: string | null;
  resourceDomain: string | null;
  resourceClassificationLevel: string | null;
  pageNumber: number;
  pageSize: number;
  toShowFor: { user: boolean; userGroup: boolean };

  constructor(input: {
    systemId: string;
    systemResourceType: string;
    resource: string | null;
    obtainedVia: string | null;
    principalId: string | null;
    userGroupType: string | null;
    userGroupId: string | null;
    resourceGroup: string | null;
    resourceDomain: string | null;
    resourceClassificationLevel: string | null;
    pageNumber: number;
    pageSize: number;
    toShowFor: { user: boolean; userGroup: boolean };
  }) {
    this.systemId = input.systemId;
    this.pageNumber = input.pageNumber;
    this.pageSize = input.pageSize;
    this.principalId = input.principalId;
    this.obtainedVia = input.obtainedVia;
    this.systemResourceType = input.systemResourceType;
    this.resource = input.resource;
    this.userGroupType = input.userGroupType;
    this.userGroupId = input.userGroupId;
    this.resourceGroup = input.resourceGroup;
    this.resourceDomain = input.resourceDomain;
    this.resourceClassificationLevel = input.resourceClassificationLevel;
    this.toShowFor = input.toShowFor;
  }

  principal(): Nullable<PrincipalFilter> {
    if(this.principalId !== null) {
      return {
        type: PrincipalTypeEnum.User,
        email: this.principalId,
        userGroupId: null,
        userGroupType: null,
      }
    }
    if(this.userGroupId !== null && this.toShowFor.userGroup === true) {
      return {
        type: PrincipalTypeEnum.UserGroup,
        email: null,
        userGroupId: this.userGroupId,
        userGroupType: this.userGroupType,
      }
    }
    return null;
  }
  
  generateObtainVia(): Nullable<ObtainedViaFilter> {
    let name: Nullable<ObtainedViaTypes> = null;
    if (this.obtainedVia === ObtainedViaTypes.DirectAccess) {
      name = ObtainedViaTypes.DirectAccess
    }
    if (this.userGroupId !== null && this.toShowFor.user === true) {
      name = ObtainedViaTypes.UserGroup
    }
    return {
      name: this.obtainedVia,
      type: name !== null?{
        name: name,
        id: this.userGroupId,
        type: this.userGroupType
      }:null
    }
  }

  requestParams(): RequestBodyForCurrentAccessControlBasedOnInformationAssets {
    return {
      page: {
        number: this.pageNumber,
        size: this.pageSize
      },
      filters: {
        systemId: this.systemId,
        principal: this.principal(),
        systemResource: {
          type: this.systemResourceType,
          name: "",
        },
        resource: {
          name: this.resource,
          domain: this.resourceDomain,
          group: this.resourceGroup,
          classificationLevel: this.resourceClassificationLevel,
        },
        obtainedVia: this.generateObtainVia(),
      }
    };
  }
}
